import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from '../../_services/loader/loader.service';
import { Utilitarios } from '../../_common/utilitarios.common';
import { timeout } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class httpInterceptor implements HttpInterceptor {
  private requests: string[] = [];

  constructor(private loaderService: LoaderService, private router: Router) { }

  removeRequest(req: string) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }

  intercept(request: HttpRequest<any>, newRequest: HttpHandler): Observable<HttpEvent<any>> {
    const publicUrls = ['/api/LinksCompartilhados/Visualizar'];

    // Verifica se a requisição é para uma URL pública
    const isPublic = publicUrls.some(url => request.url.includes(url));

    if (isPublic) {
      return newRequest.handle(request); // Não adiciona cabeçalho de autenticação
    }

    this.requests.push(request.url);
    this.loaderService.isLoading.next(true);

    let tokenInfo = new Utilitarios().RetornarLocalStorageAutenticacao();

    if (tokenInfo && tokenInfo.dsToken) {
      if (this.isTokenExpired(tokenInfo.dsToken)) {
        new Utilitarios().RemoverItemLocalStorageAutenticacao();

        this.router.navigate(['/pages/login']);
      }

      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${tokenInfo.dsToken}`,
          'Content-Type': 'application/json'
        }
      });
    }

    return Observable.create(observer => {

      const subscription = newRequest.handle(request).pipe(timeout(180000))
        .subscribe(
          event => {
            if (event instanceof HttpResponse) {
              this.removeRequest(request.url);
              observer.next(event);
            }
          },
          err => {
            this.removeRequest(request.url);
            observer.error(err);
          },
          () => {
            this.removeRequest(request.url);
            observer.complete();
          });
      // teardown logic in case of cancelled requests
      return () => {
        this.removeRequest(request.url);
        subscription.unsubscribe();
      };
    });
  }

  private isTokenExpired(token: string): boolean {
    try {

      const decoded: any = this.parseJwt(token);
      const exp = decoded.exp;
      if (!exp) return true;

      const now = Math.floor(Date.now() / 1000);

      return exp < now;
    } catch (e) {
      return true; // erro ao decodificar = token inválido
    }
  }

  private parseJwt(token: string): any {
    try {

      const base64Payload = token.split('.')[1];
      const payload = atob(base64Payload);

      return JSON.parse(payload);

    } catch (e) {
      return null;
    }
  }
}
